import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebsiteAfter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 235 100",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "axis",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.0051,0,0,1.0051,-146.214,-284.005)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M159.92,350.334L363.949,350.334",
					style: {
						fill: "none",
						stroke: "black",
						strokeOpacity: .05,
						strokeWidth: "0.99px"
					}
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-877.16,-66.597)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(13,0,0,13,1095.64,150.104)" }), /* @__PURE__ */ _jsxs("text", {
					x: "1059.3px",
					y: "150.104px",
					style: {
						fontFamily: "'Aileron-Regular', 'Aileron'",
						fontSize: 13,
						fill: "rgb(183,183,183)"
					},
					children: [
						"T",
						/* @__PURE__ */ _jsx("tspan", {
							x: "1066.45px ",
							y: "150.104px ",
							children: "o"
						}),
						"day"
					]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-989.296,-104.452)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(13,0,0,13,1074.72,186.377)" }), /* @__PURE__ */ _jsx("text", {
					x: "1003.97px",
					y: "186.377px",
					style: {
						fontFamily: "'Aileron-Regular', 'Aileron'",
						fontSize: 13,
						fill: "rgb(183,183,183)"
					},
					children: "90 days ago"
				})]
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		id: "website-AFTER",
		transform: "matrix(1,0,0,1,1.3155,3.44452)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "website_operations_1",
				transform: "matrix(1,0,0,0.621806,-768.073,-100.448)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M783.04,231.969C783.04,231.969 828.036,237.724 844.969,238.438C858.201,238.996 873.566,237.164 884.641,236.253C893.604,235.515 902.564,234.535 911.42,232.969C920.601,231.345 930.968,228.459 939.727,226.511",
					style: {
						fill: "none",
						stroke: "rgb(76,175,80)",
						strokeWidth: "4.2px"
					}
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-771.073,-207.663)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(15,0,0,15,988.127,235.43)" }), /* @__PURE__ */ _jsxs("text", {
					x: "941.192px",
					y: "235.43px",
					style: {
						fontFamily: "'Aileron-Black', 'Aileron'",
						fontWeight: 900,
						fontSize: 15,
						fill: "rgb(76,175,80)"
					},
					children: ["G", /* @__PURE__ */ _jsx("tspan", {
						x: "952.802px 964.847px 976.892px ",
						y: "235.43px 235.43px 235.43px ",
						children: "OOD"
					})]
				})]
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "website_operations_2",
				transform: "matrix(1,0,0,0.621806,-768.073,-100.448)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M941.291,226.088C948.771,224.386 957.774,222.271 963.974,221.279C969.559,220.385 983.674,219.867 983.674,219.867",
					style: {
						fill: "none",
						stroke: "rgb(76,175,80)",
						strokeWidth: "4.2px"
					}
				})
			})
		]
	})]
});
export default SvgWebsiteAfter;
